import { MenuDefinition } from '../../core/types/editor.types';

export const FILE_MENU: MenuDefinition = {
  id: 'file',
  label: 'File',
  items: [
    { id: 'new-project', label: 'New Project', shortcut: 'Ctrl+Shift+N' },
    { id: 'open-project', label: 'Open Project', shortcut: 'Ctrl+O' },
    { id: 'separator-1', label: '', separator: true },
    { id: 'build', label: 'Build & Run', shortcut: 'Ctrl+B' },
    { id: 'build-settings', label: 'Build Settings...' },
    { id: 'separator-2', label: '', separator: true },
    { id: 'close-project', label: 'Close Project' },
  ],
};

export const EDIT_MENU: MenuDefinition = {
  id: 'edit',
  label: 'Edit',
  items: [
    { id: 'undo', label: 'Undo', shortcut: 'Ctrl+Z' },
    { id: 'redo', label: 'Redo', shortcut: 'Ctrl+Y' },
    { id: 'separator-1', label: '', separator: true },
    { id: 'cut', label: 'Cut', shortcut: 'Ctrl+X' },
    { id: 'copy', label: 'Copy', shortcut: 'Ctrl+C' },
    { id: 'paste', label: 'Paste', shortcut: 'Ctrl+V' },
    { id: 'duplicate', label: 'Duplicate', shortcut: 'Ctrl+D' },
    { id: 'delete', label: 'Delete', shortcut: 'Delete' },
  ],
};

export const GAMEOBJECT_MENU: MenuDefinition = {
  id: 'gameobject',
  label: 'GameObject',
  items: [
    { id: 'create-empty', label: 'Create Empty', shortcut: 'Ctrl+Shift+E' },
    { id: 'separator-1', label: '', separator: true },
    { id: 'create-sprite', label: 'Create Sprite' },
    { id: 'create-container', label: 'Create Container' },
    { id: 'create-text', label: 'Create Text' },
    { id: 'create-graphics', label: 'Create Graphics' },
    { id: 'separator-2', label: '', separator: true },
    { id: 'games-submenu', label: 'Games', icon: 'Gamepad2', submenu: [] },
  ],
};

export const WINDOW_MENU: MenuDefinition = {
  id: 'window',
  label: 'Window',
  items: [
    { id: 'hierarchy', label: 'Hierarchy', shortcut: 'Ctrl+1', checked: true },
    { id: 'scene-view', label: 'Scene View', shortcut: 'Ctrl+2', checked: true },
    { id: 'inspector', label: 'Inspector', shortcut: 'Ctrl+3', checked: true },
    { id: 'project', label: 'Project', shortcut: 'Ctrl+4', checked: true },
    { id: 'separator-1', label: '', separator: true },
    { id: 'script-editor', label: 'Script Editor', shortcut: 'Ctrl+5' },
    { id: 'animation-editor', label: 'Animation Editor', shortcut: 'Ctrl+6' },
    { id: 'live-preview', label: 'Live Preview', shortcut: 'Ctrl+7' },
    { id: 'console', label: 'Console', shortcut: 'Ctrl+8' },
    { id: 'slot-asset-generator', label: 'Slot Asset Generator', shortcut: 'Ctrl+Shift+A', icon: 'Gamepad2' },
    { id: 'slot-screen-generator', label: 'Slot Screen Generator', shortcut: 'Ctrl+Shift+M', icon: 'Monitor' },
  ],
};

export const ALL_MENUS: MenuDefinition[] = [
  FILE_MENU,
  EDIT_MENU,
  GAMEOBJECT_MENU,
  WINDOW_MENU,
];
